import React from 'react';
import "./SectionComments.scss";
import { Comment, TitleSecondary } from "../";

const SectionComents = () => {
    return (
        <>
            <div className="section-comments">
                <TitleSecondary>Testimonios</TitleSecondary>
                <p>Más de 30.000 personas confían en Solucionarte para encargarse de sus tediosas tareas</p>
                <div className="section-comments__container">
                    <Comment
                        image="https://images.pexels.com/photos/5704720/pexels-photo-5704720.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        name="Melisa Carrera"
                        occupation="Abogada"
                        valoration="5"
                        text="Excelente servicio. Pude resolver el problema que tenia muy rapido, ya que me contactaron inmediatamente."
                    />
                    <Comment
                        image="https://images.pexels.com/photos/1212984/pexels-photo-1212984.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        name="Damian Diaz"
                        occupation="Diseñador grafico"
                        valoration="5"
                        text="Excelente servicio. Pude resolver el problema que tenia muy rapido, ya que me contactaron inmediatamente."
                    />
                    <Comment
                        image="https://images.pexels.com/photos/936119/pexels-photo-936119.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        name="Carlos Vela"
                        occupation="Administrador de empresas"
                        valoration="5"
                        text="Excelente servicio. Pude resolver el problema que tenia muy rapido, ya que me contactaron inmediatamente."
                    />
                    <Comment
                        image="https://images.pexels.com/photos/2262810/pexels-photo-2262810.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        name="Macarena Rodriguez"
                        occupation="Profesora"
                        valoration="5"
                        text="Excelente servicio. Pude resolver muy rapido el problema que tenia, ya que me contactaron inmediatamente."
                    />
                </div>
            </div>
        </>
    )
}

export default SectionComents;
